import type { CreditBalance, CreditBalanceResponse } from '../types';

export const mapCreditBalance = (data: CreditBalanceResponse): CreditBalance => {
  return {
    totalCredits: data.total_credits,
    remainingCredits: data.remaining_credits,
    allowOverage: data.allow_overages,
  };
};
